import { Component, Input, computed } from '@angular/core';

type Status = 'active' | 'invited' | 'inactive' | 'live' | 'draft';

const COLORS: Record<Status, string> = {
  active: '#4ade80', invited: '#ff9b1d', inactive: '#727272', live: '#4ade80', draft: '#ff9b1d',
};
const LABELS: Record<Status, string> = {
  active: 'Aktiv', invited: 'Eingeladen', inactive: 'Inaktiv', live: 'Live', draft: 'Entwurf',
};

/**
 * Colored indicator dot that visualises an entity's lifecycle status with an optional text label.
 */
@Component({
  selector: 'es-status-dot',
  template: `
    <span class="inline-flex items-center gap-1.5 text-xs text-[var(--text-secondary)]">
      <span class="w-2 h-2 rounded-full" [style.background]="color()"></span>
      @if (showLabel) { {{ label() }} }
    </span>
  `,
})
export class StatusDotComponent {
  @Input({ required: true }) status!: Status;
  @Input() showLabel = true;

  color = computed(() => COLORS[this.status] ?? '#727272');
  label = computed(() => LABELS[this.status] ?? this.status);
}
